'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconMenu = require('material-ui/IconMenu');

var _IconMenu2 = _interopRequireDefault(_IconMenu);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _MenuItem = require('material-ui/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _expandMore = require('material-ui/svg-icons/navigation/expand-more');

var _expandMore2 = _interopRequireDefault(_expandMore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconDropdown = function (_Component) {
  _inherits(IconDropdown, _Component);

  function IconDropdown() {
    _classCallCheck(this, IconDropdown);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(IconDropdown).apply(this, arguments));
  }

  _createClass(IconDropdown, [{
    key: 'render',
    value: function render() {

      var icon = this.props.icon || _react2.default.createElement(_expandMore2.default, null);
      var items = this.props.items || [];

      return _react2.default.createElement(
        _IconMenu2.default,
        {
          iconButtonElement: _react2.default.createElement(
            _IconButton2.default,
            { touch: true },
            icon
          ) },
        items.map(function (item, i) {
          return _react2.default.createElement(_MenuItem2.default, { key: i, primaryText: item.title, onTouchTap: function onTouchTap() {
              item.handler && item.handler();
            } });
        })
      );
    }
  }]);

  return IconDropdown;
}(_react.Component);

exports.default = IconDropdown;


/** WEBPACK FOOTER **
 ** ../kettle-ui/lib/IconDropdown.js
 **/